module.exports = __webpack_public_path__ + "static/media/18Chocolate.8a0fe211.jpg";